import { Col, DatePicker, Row, Select, Form, Input, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import AttachmentButton from "../expandedRow/AttachmentButton";
import "../expandedRow/expandedRow.css";
import moment from "moment";

const RevisionsExpandedRow = ({ fields, formRef, onFinish, isRevisionUpdateCase, record, project_id, isEditing, editingKey, editingLoading }) => {

  const renderViewItem = (field, value) => {
    const { id, name, field_type, field_options } = field;
    
    // Format the value based on field type
    let displayValue = value;
    
    switch (field_type) {
      case "select_field":
        // For select fields, find the option name that matches the value
        if (field_options && Array.isArray(field_options)) {
          const option = field_options.find(opt => opt.id === value || opt.value === value);
          displayValue = option ? option.name : value;
        }
        break;
      case "date_field":
        // Format date values
        if (value) {
          try {
            const date = new Date(value);
            displayValue = date.toLocaleDateString();
          } catch (e) {
            // If date parsing fails, use the original value
          }
        }
        break;
      default:
        // Use the value as is for other field types
        break;
    }
    
    // Return a div with the field name and value
    return (
      <div className="view-field-container">
        <div className="view-field-label">{name}</div>
        <div className="view-field-value">{displayValue || '-'}</div>
      </div>
    );
  };

  // Function to render form items based on field type
  const renderFormItem = (field) => {
    const { id, name, field_type, required, disabled, field_options } = field;
    
    // Set required rule if specified
    const rules = required ? [{ required: true, message: `Please enter ${name}` }] : [];
    
    switch (field_type) {
      case "text_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input disabled={disabled} />
          </Form.Item>
        );
      case "date_field":
        return (
          <Form.Item label={name} name={id} rules={rules} getValueProps={(value) => {
            // Ensure value is a moment object
            if (value && !moment.isMoment(value)) {
              return { value: moment(value) };
            }
            return { value };
          }}>
            <DatePicker 
              placeholder="Select Date" 
              style={{ width: '100%' }} 
              disabled={disabled}
              showTime={name.includes("TIME")}
              format={name.includes("TIME") ? "DD MMM YYYY HH:mm" : "DD MMM YYYY"}
              suffixIcon={<span className="ant-picker-suffix"></span>}
            />
          </Form.Item>
        );
      case "select_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Select placeholder={`Select ${name}`} disabled={disabled}>
              {field_options?.map(option => (
                <Select.Option key={option.id} value={option.id}>{option.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      case "date_field":
        return (
          <Form.Item label={name} name={id} rules={rules} getValueProps={(value) => {
            // Ensure value is a moment object
            if (value && !moment.isMoment(value)) {
              return { value: moment(value) };
            }
            return { value };
          }}>
            <DatePicker 
              showTime={name.includes("TIME")} 
              style={{ width: '100%' }} 
              disabled={disabled} 
              format={name.includes("TIME") ? "DD MMM YYYY HH:mm" : "DD MMM YYYY"}
            />
          </Form.Item>
        );
      case "upload_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Upload>
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>
        );
      case "textarea_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input.TextArea rows={4} disabled={disabled} />
          </Form.Item>
        );
      default:
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input disabled={disabled} />
          </Form.Item>
        );
    }
  };

//   // Check if this is a Material form
//   const isMaterialForm = fields.some(field => field.id === "areaName" && field.id === "materialSpec");
  const isMaterialForm = fields.some(field => field.id === "areaName") && fields.some(field => field.id === "materialSpec");
  const isBoltsForm = fields.some(field => field.id === "area") && fields.some(field => field.id === "size");

  // If this is a Bolts form, render the bolts layout
  if (isBoltsForm || (record && (record.type === "Bolts" || record.type?.toLowerCase() === "bolts"))) {
    return (
      <Row>
        <Col span={24}>
          <Form
            className="ims-doc-fields-form"
            form={formRef}
            onFinish={onFinish}
            layout="vertical"
          >
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">AREA NAME</div>
                    <div className="view-field-value">{record.areaName || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
              {(
                  <div className="view-field-container">
                    <div className="view-field-label">ORIGINAL PRIORITY</div>
                    <div className="view-field-value">
                      {record.originalPriority ? record.originalPriority.name : '-'}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">NEW PRIORITY</div>
                    <div className="view-field-value">
                      {record.newPriority ? record.newPriority.name : '-'}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">UNIT SUBTOTAL / NET</div>
                    <div className="view-field-value">{record.unitSubtotal || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">UNIT WEIGHT (kg)</div>
                    <div className="view-field-value">{record.unitWeight || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">TOTAL WEIGHT (kg)</div>
                    <div className="view-field-value">{record.totalWeight || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">SIZE</div>
                    <div className="view-field-value">{record.size || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">LENGTH (mm)</div>
                    <div className="view-field-value">{record.length || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">MODEL</div>
                    <div className="view-field-value">{record.model || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">MATERIAL FINISH</div>
                    <div className="view-field-value">{record.materialFinish || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">GRADE</div>
                    <div className="view-field-value">{record.grade || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">FASTENER TYPE</div>
                    <div className="view-field-value">{record.fastenerType || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">SUPPLIER</div>
                    <div className="view-field-value">
                      {record.supplier ? record.supplier.name : '-'}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">ATTACHMENTS</div>
                    <div className="view-field-value">
                      {record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#f25003', borderColor: '#f25003'}} count={record.attachments.length} /> : '-'}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">COMMENTS</div>
                    <div className="view-field-value">{record.comments || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">STATUS</div>
                    <div className="view-field-value">{record.status || '-'}</div>
                  </div>
                )}
              </Col>
              {record?.status && record?.status === 'On Hold' && (
                <>
                  <Col span={6}>
                    {(
                      <div className="view-field-container">
                        <div className="view-field-label">ON HOLD REASON</div>
                        <div className="view-field-value">{record.onHoldReason || '-'}</div>
                      </div>
                    )}
                  </Col>
                  <Col span={6}>
                    {(
                      <div className="view-field-container">
                        <div className="view-field-label">ON HOLD DETAILS</div>
                        <div className="view-field-value">
                          <div>Date: {record.onHoldAt ? moment(record.onHoldAt).format("DD MMM YYYY") : '-'}</div>
                          <div>Changed By: {record.onHoldBy ? `${record.onHoldBy.firstName} ${record.onHoldBy.lastName}` : '-'}</div>
                        </div>
                      </div>
                    )}
                  </Col>
                </>
              )}
            </Row>
            <div className="created-modified-field-group">
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="created-modified-field-label">CREATED BY</div>
                    <div className="created-modified-field-value">{ record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="created-modified-field-label">CREATED DATE & TIME</div>
                    <div className="created-modified-field-value">{record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="created-modified-field-label">MODIFIED BY</div>
                    <div className="created-modified-field-value">{record.updatedBy ? `${record.updatedBy.firstName} ${record.updatedBy.lastName}` : '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="created-modified-field-label">MODIFIED DATE & TIME</div>
                    <div className="created-modified-field-value">{record.modifiedDate ? moment(record.modifiedDate).format("DD MMM YYYY HH:mm") : '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            </div>
            {/* Dynamic fields from template */}
            {fields.filter(field => ![
              'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'unitWeight', 'totalWeight',
              'size', 'length', 'model', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'attachments',
              'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
            ].includes(field.id)).length > 0 && (
              <>
                <Row>
                  <Col span={24}>
                    <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
                </Row>
                <Row gutter={[20, 10]}>
                  {fields.filter(field => ![
                        'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'unitWeight', 'totalWeight',
                        'size', 'length', 'model', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'commodityId', 'attachments',
                        'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                  ].includes(field.id)).map(field => (
                    <Col span={6} key={field.id}>
                      {renderViewItem(field, (record.materialTemplateFields && record.materialTemplateFields[field.id]) || '-')}
                    </Col>
                  ))}
                </Row>
                <Row>
                  <Col span={24}>
                    <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
                </Row>
              </>
            )}
            {/* Only show tracking stages when record has been saved (has an ID and is not in editing mode) */}
            {record && record.id && !isEditing && (
              <Row gutter={[16, 10]} style={{ marginTop: '15px'}}>
                <Col span={4}>
                  <div className="tracking-stage fabrication-stage">
                    <div className="tracking-stage-header">FABRICATION</div>
                    <div className="tracking-stage-status">
                      <div className={`status-badge ${record && record.fabricationStatus === 'completed' ? 'completed' : (record && record.fabricationStatus === 'in_progress' ? 'in-progress' : (record && record.fabricationStatus === 'received' ? 'received' : ''))}`}>
                        {record && record.fabricationStatus ? 
                          record.fabricationStatus === 'in_progress' ? 'In Progress' : 
                          record.fabricationStatus.charAt(0).toUpperCase() + record.fabricationStatus.slice(1) 
                        : 'Not Started'}
                      </div>
                    </div>
                    <div className="field-group mark-recieved">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-date-display">
                            {record.progressSteps[0].receivedAt ? moment(record.progressSteps[0].receivedAt).format('DD MMM YYYY') : ''}
                            <div className="saved-icons-container">
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[0].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[0].receivedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressStep[0].receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isAuthorized}
                              type="fabrication"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-location-display">
                            {record.progressSteps[0].receivedLocation ? record.progressSteps[0].receivedLocation.name : ''}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-location-display">
                            {record.progressSteps[0].receivedBy ? record.progressSteps[0].receivedBy.firstName + ' ' + record.progressSteps[0].receivedBy.lastName : ''}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      
                    </div>
                    </div>
                    <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-date-display">
                            {record.progressSteps[0].completedAt ? moment(record.progressSteps[0].completedAt).format('DD MMM YYYY') : ''}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[0].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[0].completedQty || 0} of {record.qty || 1}
                            </span>
                            {Number(record.progressSteps[0].completedQty) > Number(record.qty || 1)
                            //  && 
                            // (
                            //   <AuthorizeExcess
                            //     receivedQty={record.progressSteps[0].completedQty}
                            //     expectedQty={record.qty || 1}
                            //     record={record}
                            //     currentUser={currentUser}
                            //     isAuthorized={isCompletedAuthorized}
                            //     type="fabrication"
                            //     onAuthorize={handleSaveMarkCompleted}
                            //     authorizationData={authorizationCompletedData}
                            //   />
                            // )
                            }
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-location-display">
                            {record.progressSteps[0].completedLocation ? record.progressSteps[0].completedLocation.name : ''}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {record && record.progressSteps ? (
                          <div className="saved-location-display">
                            {record && record.progressSteps && record.progressSteps[0] && record.progressSteps[0].completedBy ? record.progressSteps[0].completedBy.firstName + ' ' + record.progressSteps[0].completedBy.lastName : ''}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[0] ? record.progressSteps[0].totalGross || "" : ""}
                      </div>
                    </div>
                    </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">SUPPLIER</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[0] ? (
                            <div className="saved-supplier-display">
                              <span className="supplier-name">
                              {record.progressSteps[0].supplier ? record.progressSteps[0].supplier.name : ''}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="tracking-stage-field">
                      <div className="field-label">ATTACHMENTS</div>
                        <div className="field-value"></div>
                        {true ? (
                          <Form.Item>
                            <Upload>
                              <AttachmentButton style={{color: '#8e44ad', borderColor: '#8e44ad'}} count={0} />
                            </Upload>
                          </Form.Item>
                        ) : (
                          record && record.attachments && record.attachments.length > 0 ? 
                          <AttachmentButton style={{color: '#8e44ad', borderColor: '#8e44ad'}} count={record.attachments.length} /> : '-'
                        )}
                      </div>
                    </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage qc-release-stage">
                  <div className="tracking-stage-header">QC RELEASE</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${record && record.qcReleaseStatus === 'completed' ? 'completed' : (record && record.qcReleaseStatus === 'in_progress' ? 'in-progress' : (record && record.qcReleaseStatus === 'received' ? 'received' : ''))}`}>
                        {record && record.qcReleaseStatus ? 
                          record.qcReleaseStatus === 'in_progress' ? 'In Progress' : 
                          record.qcReleaseStatus.charAt(0).toUpperCase() + record.qcReleaseStatus.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].receivedDate ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(record.progressSteps[1].receivedDate).format('DD MMM YYYY')}</span>
                        </div>
                      ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {record && record.progressSteps && record.progressSteps[1] ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(record.progressSteps[1].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {record.progressSteps[1].receivedQty || 0} of {record.qty || 1}
                              </span>
                              {/* <AuthorizeExcess
                                receivedQty={qcQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isQcAuthorized}
                                type="qc_release"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationQcReceivedData}
                              /> */}
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? (
                          <div className="saved-location-display">
                            {record.progressSteps[1].receivedLocation ? record.progressSteps[1].receivedLocation.name : ''}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].receivedBy ? record.progressSteps[1].receivedBy.firstName + ' ' + record.progressSteps[1].receivedBy.lastName : ''}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{record.progressSteps[1].completedDate ? moment(record.progressSteps[1].completedDate).format('DD MMM YYYY') : ''}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          {record && record.progressSteps && record.progressSteps[1] ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(record.progressSteps[1].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {record.progressSteps[1].completedQty || 0} of {record.qty || 1}
                              </span>
                              {Number(record.progressSteps[1].completedQty) > Number(record.qty || 1) 
                              // && (
                              //   <AuthorizeExcess
                              //     receivedQty={qcCompletedQty}
                              //     expectedQty={record.qty || 1}
                              //     record={record}
                              //     currentUser={currentUser}
                              //     isAuthorized={isQcCompletedAuthorized}
                              //     type="qc_release"
                              //     onAuthorize={handleSaveMarkCompleted}
                              //     authorizationData={authorizationQcCompletedData}
                              //   />
                              // )
                              }
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[1] ? (
                          <div>{record.progressSteps[1].completedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].completedBy ? record.progressSteps[1].completedBy.firstName + ' ' + record.progressSteps[1].completedBy.lastName : ''}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? record.progressSteps[1].totalGross || "" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">SUPPLIER</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {record.progressSteps[1].supplier?.name || ''}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#c0392b', borderColor: '#c0392b'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#c0392b', borderColor: '#c0392b'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-to-workshop-stage">
                  <div className="tracking-stage-header">CORROSION PROT</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${record && record.corrosionProtectionStatus === 'completed' ? 'completed' : (record && record.corrosionProtectionStatus === 'in_progress' ? 'in-progress' : (record && record.corrosionProtectionStatus === 'received' ? 'received' : ''))}`}>
                        {record && record.corrosionProtectionStatus ? 
                          record.corrosionProtectionStatus === 'in_progress' ? 'In Progress' : 
                          record.corrosionProtectionStatus.charAt(0).toUpperCase() + record.corrosionProtectionStatus.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].receivedDate ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(record.progressSteps[2].receivedDate).format('DD MMM YYYY')}</span>
                          {/* <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                          </div> */}
                        </div>
                      ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {record && record.progressSteps && record.progressSteps[2] ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(record.progressSteps[2].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {record.progressSteps[2].receivedQty || 0} of {record.qty || 1}
                              </span>
                              {/* <AuthorizeExcess
                                receivedQty={record.progressSteps[2].receivedQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isCorrosionAuthorized}
                                type="corrosion_protection"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationCorrosionReceivedData}
                              /> */}
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[2] ? (
                          <div>{record.progressSteps[2].receivedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].receivedBy ? record.progressSteps[2].receivedBy.firstName + ' ' + record.progressSteps[2].receivedBy.lastName : ''}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[2] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{record.progressSteps[2].completedDate ? moment(record.progressSteps[2].completedDate).format('DD MMM YYYY') : ''}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                      <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          { record && record.progressSteps && record.progressSteps[2] ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(record.progressSteps[2].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {record.progressSteps[2].completedQty || 0} of {record.qty || 1}
                              </span>
                              {Number(record.progressSteps[2].completedQty) > Number(record.qty || 1)
                              //  && (
                              //   <AuthorizeExcess
                              //     receivedQty={corrosionCompletedQty}
                              //     expectedQty={record.qty || 1}
                              //     record={record}
                              //     currentUser={currentUser}
                              //     isAuthorized={isCorrosionCompletedAuthorized}
                              //     type="corrosion_protection"
                              //     onAuthorize={handleSaveMarkCompleted}
                              //     authorizationData={authorizationCorrosionCompletedData}
                              //   />
                              // )
                              }
                              </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                      <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[2] ? (
                          <div>{record.progressSteps[2].completedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].completedBy ? record.progressSteps[2].completedBy.firstName + ' ' + record.progressSteps[2].completedBy.lastName : ''}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[2] ? record.progressSteps[2].totalGross || "" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">SUPPLIER</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[2] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {record.progressSteps[2].supplier?.name || ''}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#ffc000', borderColor: '#ffc000'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#ffc000', borderColor: '#ffc000'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-stage">
                  <div className="tracking-stage-header">DELIVERY TO SITE</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${record && record.deliveryToSiteStatus === 'completed' ? 'completed' : (record && record.deliveryToSiteStatus === 'in_progress' ? 'in-progress' : (record && record.deliveryToSiteStatus === 'received' ? 'received' : ''))}`}>
                      {record && record.deliveryToSiteStatus ? 
                        record.deliveryToSiteStatus === 'in_progress' ? 'In Progress' : 
                        record.deliveryToSiteStatus.charAt(0).toUpperCase() + record.deliveryToSiteStatus.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].receivedDate ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(record.progressSteps[3].receivedDate).format('DD MMM YYYY')}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[3].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[3].receivedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressSteps[3].receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isDeliveryAuthorized}
                              type="delivery_to_site"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliveryReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div>{record.progressSteps[3].receivedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].receivedBy ? record.progressSteps[3].receivedBy.firstName + ' ' + record.progressSteps[3].receivedBy.lastName : ''}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{record.progressSteps[3].completedDate ? moment(record.progressSteps[3].completedDate).format('DD MMM YYYY') : ''}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[3].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[3].completedQty || 0} of {record.qty || 1}
                            </span>
                            {Number(record.progressSteps[3].completedQty) > Number(record.qty || 1)
                            //  && (
                            //   <AuthorizeExcess
                            //     receivedQty={deliveryCompletedQty}
                            //     expectedQty={record.qty || 1}
                            //     record={record}
                            //     currentUser={currentUser}
                            //     isAuthorized={isDeliveryCompletedAuthorized}
                            //     type="delivery_to_site"
                            //     onAuthorize={handleSaveMarkCompleted}
                            //     authorizationData={authorizationDeliveryCompletedData}
                            //   />
                            // )
                            }
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div>{record.progressSteps[3].completedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].completedBy ? record.progressSteps[3].completedBy.firstName + ' ' + record.progressSteps[3].completedBy.lastName : ''}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? record.progressSteps[3].totalGross || "" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">SUPPLIER</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[3] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {record.progressSteps[3].supplier?.name || ''}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#3498db', borderColor: '#3498db'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#3498db', borderColor: '#3498db'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage receipt-stage">
                  <div className="tracking-stage-header">SITE RECEIPT</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${record && record.siteReceiptStatus === 'completed' ? 'completed' : (record && record.siteReceiptStatus === 'in_progress' ? 'in-progress' : (record && record.siteReceiptStatus === 'received' ? 'received' : ''))}`}>
                      {record && record.siteReceiptStatus ? 
                        record.siteReceiptStatus === 'in_progress' ? 'In Progress' : 
                        record.siteReceiptStatus.charAt(0).toUpperCase() + record.siteReceiptStatus.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].receivedDate ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(record.progressSteps[4].receivedDate).format('DD MMM YYYY')}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[4].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[4].receivedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressSteps[4].receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliverytoSiteReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[4] ? (
                          <div>{record.progressSteps[4].receivedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].receivedBy ? record.progressSteps[4].receivedBy.firstName + ' ' + record.progressSteps[4].receivedBy.lastName : ''}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{record.progressSteps[4].completedDate ? moment(record.progressSteps[4].completedDate).format('DD MMM YYYY') : ''}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[4].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[4].completedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressSteps[4].completedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptCompletedAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkCompleted}
                              authorizationData={authorizationDeliverytoSiteCompletedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? (
                          <div>{record.progressSteps[4].completedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].completedBy ? record.progressSteps[4].completedBy.firstName + ' ' + record.progressSteps[4].completedBy.lastName : ''}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? record.progressSteps[4].totalGross || "" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">SUPPLIER</div>
                        <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[4] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {record.progressSteps[4].supplier?.name || ''}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
                </div>
              </Col>

            </Row>
            )}
          </Form>
        </Col>
      </Row>
    );
  }

  if (isMaterialForm || (record && (record.type === "Material" || record.type?.toLowerCase() === "material"))) {
  // Get the form values for view mode
  const formValues = formRef.getFieldsValue();

  return (
      <Row>
      <Col span={24}>
          <Form
          className="ims-doc-fields-form"
          form={formRef}
          onFinish={onFinish}
          layout="vertical"
          >
          <Row gutter={[20, 10]}>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">AREA NAME</div>
                  <div className="view-field-value">{record.areaName || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">ORIGINAL PRIORITY</div>
                  <div className="view-field-value">
                  {(() => {
                      return record.originalPriority ? record.originalPriority.name : '-';
                  })()}
                  </div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">NEW PRIORITY</div>
                  <div className="view-field-value">
                  {(() => {
                      return record.newPriority ? record.newPriority.name : '-';
                  })()}
                  </div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">UNIT SUBTOTAL / NET</div>
                  <div className="view-field-value">{record.unitSubtotal ? `${record.unitSubtotal}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : '-'}</div>
                  </div>
              )}
          </Col>
          </Row>
          <Row gutter={[20, 10]}>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">MODEL</div>
                  <div className="view-field-value">{record.model || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">PROFILE / MEMBER</div>
                  <div className="view-field-value">{record.profileMember || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">MATERIAL SPEC</div>
                  <div className="view-field-value">{record.materialSpec || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">LENGTH (mm)</div>
                  <div className="view-field-value">{record.length || '-'}</div>
              </div>
              )}
          </Col>
          </Row>
          <Row gutter={[20, 10]}>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">PAINT AREA EACH (m²)</div>
                  <div className="view-field-value">{record.paintArea || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">SUPPLIER</div>
                  <div className="view-field-value">
                  {(() => {
                      return record.supplier ? record.supplier.name : '-';
                  })()}
                  </div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">COMMODITY</div>
                  <div className="view-field-value">
                  {(() => {
                      return record.commodity ? record.commodity.name : '-';
                  })()}
                  </div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">ATTACHMENTS</div>
                  <div className="view-field-value">
                  <AttachmentButton style={{color: '#f25003', borderColor: '#f25003'}} count={0} />
                  </div>
              </div>
              )}
          </Col>
          </Row>
          <Row gutter={[20, 10]}>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">COMMENTS</div>
                  <div className="view-field-value">{record.comments || '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="view-field-label">STATUS</div>
                  <div className="view-field-value">{record.status || '-'}</div>
              </div>
              )}
          </Col>
          {record?.status && record?.status === 'On Hold' && (
            <>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">ON HOLD REASON</div>
                    <div className="view-field-value">{record.onHoldReason || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {(
                  <div className="view-field-container">
                    <div className="view-field-label">ON HOLD DETAILS</div>
                    <div className="view-field-value">
                      <div>Date: {record.onHoldAt ? moment(record.onHoldAt).format("DD MMM YYYY") : '-'}</div>
                      <div>Changed By: {record.onHoldBy ? `${record.onHoldBy.firstName} ${record.onHoldBy.lastName}` : '-'}</div>
                    </div>
                  </div>
                )}
              </Col>
            </>
          )}
          </Row>
          <div className="created-modified-field-group">
          <Row gutter={[20, 10]}>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="created-modified-field-label">CREATED BY</div>
                  <div className="created-modified-field-value">{record.createdBy ? record.createdBy.firstName + " " + record.createdBy.lastName : '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="created-modified-field-label">CREATED DATE & TIME</div>
                  <div className="created-modified-field-value">{record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="created-modified-field-label">MODIFIED BY</div>
                  <div className="created-modified-field-value">{record.updatedBy ? record.updatedBy.firstName + " " + record.updatedBy.lastName : '-'}</div>
              </div>
              )}
          </Col>
          <Col span={6}>
              {(
              <div className="view-field-container">
                  <div className="created-modified-field-label">MODIFIED DATE & TIME</div>
                  <div className="created-modified-field-value">{record.modifiedDate ? moment(record.modifiedDate).format("DD MMM YYYY HH:mm") : '-'}</div>
              </div>
              )}
          </Col>
          </Row>
          </div>
          {/* Dynamic fields from template */}
          {fields.filter(field => ![
              'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'model', 'profileMember',
              'materialSpec', 'length', 'paintArea', 'supplierId', 'commodityId', 'attachments', 'comments',
              'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
          ].includes(field.id)).length > 0 && (
              <>
              <Row>
                  <Col span={24}>
                  <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
              </Row>
              <Row gutter={[20, 10]}>
                  {fields.filter(field => ![
                  'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'model', 'profileMember',
                  'materialSpec', 'length', 'paintArea', 'supplierId', 'commodityId', 'attachments', 'comments',
                  'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                  ].includes(field.id)).map(field => (
                  <Col span={6} key={field.id}>
                      {isEditing ? (
                      renderFormItem(field)
                      ) : (
                      renderViewItem(field, (record.materialTemplateFields && record.materialTemplateFields[field.id]) || '-')
                      )}
                  </Col>
                  ))}
              </Row>
              <Row>
                  <Col span={24}>
                  <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
              </Row>
              </>
          )}
          {/* Only show tracking stages when record has been saved (has an ID and is not in editing mode) */}
          {record && record.id && !isEditing && (
            <Row gutter={[16, 10]} style={{ marginTop: '15px'}}>
              <Col span={4}>
                <div className="tracking-stage fabrication-stage">
                  <div className="tracking-stage-header">FABRICATION</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${record && record.fabricationStatus === 'completed' ? 'completed' : (record && record.fabricationStatus === 'in_progress' ? 'in-progress' : (record && record.fabricationStatus === 'received' ? 'received' : ''))}`}>
                      {record && record.fabricationStatus ? 
                        record.fabricationStatus === 'in_progress' ? 'In Progress' : 
                        record.fabricationStatus.charAt(0).toUpperCase() + record.fabricationStatus.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-recieved">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-date-display">
                          {record.progressSteps[0].receivedAt ? moment(record.progressSteps[0].receivedAt).format('DD MMM YYYY') : ''}
                          <div className="saved-icons-container">
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[0].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[0].receivedQty || 0} of {record.qty || 1}
                          </span>
                          {/* <AuthorizeExcess
                            receivedQty={record.progressStep[0].receivedQty}
                            expectedQty={record.qty || 1}
                            record={record}
                            currentUser={currentUser}
                            isAuthorized={isAuthorized}
                            type="fabrication"
                            onAuthorize={handleSaveMarkRecieved}
                            authorizationData={authorizationReceivedData}
                          /> */}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-location-display">
                          {record.progressSteps[0].receivedLocation ? record.progressSteps[0].receivedLocation.name : ''}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-location-display">
                          {record.progressSteps[0].receivedBy ? record.progressSteps[0].receivedBy.firstName + ' ' + record.progressSteps[0].receivedBy.lastName : ''}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    
                  </div>
                  </div>
                  <div className="field-group mark-completed">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-date-display">
                          {record.progressSteps[0].completedAt ? moment(record.progressSteps[0].completedAt).format('DD MMM YYYY') : ''}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[0].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[0].completedQty || 0} of {record.qty || 1}
                          </span>
                          {Number(record.progressSteps[0].completedQty) > Number(record.qty || 1)
                          //  && 
                          // (
                          //   <AuthorizeExcess
                          //     receivedQty={record.progressSteps[0].completedQty}
                          //     expectedQty={record.qty || 1}
                          //     record={record}
                          //     currentUser={currentUser}
                          //     isAuthorized={isCompletedAuthorized}
                          //     type="fabrication"
                          //     onAuthorize={handleSaveMarkCompleted}
                          //     authorizationData={authorizationCompletedData}
                          //   />
                          // )
                          }
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                        <div className="saved-location-display">
                          {record.progressSteps[0].completedLocation ? record.progressSteps[0].completedLocation.name : ''}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">
                      {record && record.progressSteps ? (
                        <div className="saved-location-display">
                          {record && record.progressSteps && record.progressSteps[0] && record.progressSteps[0].completedBy ? record.progressSteps[0].completedBy.firstName + ' ' + record.progressSteps[0].completedBy.lastName : ''}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">TOTAL / GROSS COMPLETED</div>
                    <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[0] ? record.progressSteps[0].totalGross || "" : ""}
                    </div>
                  </div>
                  </div>
                <div className="field-group">
                  <div className="tracking-stage-field">
                    <div className="field-label">SUPPLIER</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[0] ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {record.progressSteps[0].supplier ? record.progressSteps[0].supplier.name : ''}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#8e44ad', borderColor: '#8e44ad'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#8e44ad', borderColor: '#8e44ad'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
              </div>
            </Col>
            <Col span={4}>
              <div className="tracking-stage qc-release-stage">
                <div className="tracking-stage-header">QC RELEASE</div>
                <div className="tracking-stage-status">
                <div className={`status-badge ${record && record.qcReleaseStatus === 'completed' ? 'completed' : (record && record.qcReleaseStatus === 'in_progress' ? 'in-progress' : (record && record.qcReleaseStatus === 'received' ? 'received' : ''))}`}>
                      {record && record.qcReleaseStatus ? 
                        record.qcReleaseStatus === 'in_progress' ? 'In Progress' : 
                        record.qcReleaseStatus.charAt(0).toUpperCase() + record.qcReleaseStatus.slice(1) 
                      : 'Not Started'}
                    </div>
                </div>
                <div className="field-group mark-received">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE RECEIVED</div>
                    <div className="field-value">
                    { record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].receivedDate ? (
                      <div className="saved-supplier-display">
                        <span className="supplier-name">{moment(record.progressSteps[1].receivedDate).format('DD MMM YYYY')}</span>
                      </div>
                    ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                    <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[1].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[1].receivedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={qcQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isQcAuthorized}
                              type="qc_release"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationQcReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[1] ? (
                        <div className="saved-location-display">
                          {record.progressSteps[1].receivedLocation ? record.progressSteps[1].receivedLocation.name : ''}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].receivedBy ? record.progressSteps[1].receivedBy.firstName + ' ' + record.progressSteps[1].receivedBy.lastName : ''}</div>
                  </div>
                </div>
                <div className="field-group mark-completed">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[1] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{record.progressSteps[1].completedDate ? moment(record.progressSteps[1].completedDate).format('DD MMM YYYY') : ''}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY COMPLETED</div>
                    <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[1] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[1].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[1].completedQty || 0} of {record.qty || 1}
                            </span>
                            {Number(record.progressSteps[1].completedQty) > Number(record.qty || 1) 
                            // && (
                            //   <AuthorizeExcess
                            //     receivedQty={qcCompletedQty}
                            //     expectedQty={record.qty || 1}
                            //     record={record}
                            //     currentUser={currentUser}
                            //     isAuthorized={isQcCompletedAuthorized}
                            //     type="qc_release"
                            //     onAuthorize={handleSaveMarkCompleted}
                            //     authorizationData={authorizationQcCompletedData}
                            //   />
                            // )
                            }
                          </div>
                        ) : (
                          <div></div>
                        )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[1] ? (
                        <div>{record.progressSteps[1].completedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[1] && record.progressSteps[1].completedBy ? record.progressSteps[1].completedBy.firstName + ' ' + record.progressSteps[1].completedBy.lastName : ''}</div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">TOTAL / GROSS COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[1] ? record.progressSteps[1].totalGross || "" : ""}
                    </div>
                  </div>
                </div>
                <div className="field-group">
                  <div className="tracking-stage-field">
                    <div className="field-label">SUPPLIER</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[1] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">
                          {record.progressSteps[1].supplier?.name || ''}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                  <div className="field-label">ATTACHMENTS</div>
                    <div className="field-value"></div>
                    {true ? (
                      <Form.Item>
                        <Upload>
                          <AttachmentButton style={{color: '#c0392b', borderColor: '#c0392b'}} count={0} />
                        </Upload>
                      </Form.Item>
                    ) : (
                      record && record.attachments && record.attachments.length > 0 ? 
                      <AttachmentButton style={{color: '#c0392b', borderColor: '#c0392b'}} count={record.attachments.length} /> : '-'
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col span={4}>
              <div className="tracking-stage delivery-to-workshop-stage">
                <div className="tracking-stage-header">CORROSION PROT</div>
                <div className="tracking-stage-status">
                <div className={`status-badge ${record && record.corrosionProtectionStatus === 'completed' ? 'completed' : (record && record.corrosionProtectionStatus === 'in_progress' ? 'in-progress' : (record && record.corrosionProtectionStatus === 'received' ? 'received' : ''))}`}>
                      {record && record.corrosionProtectionStatus ? 
                        record.corrosionProtectionStatus === 'in_progress' ? 'In Progress' : 
                        record.corrosionProtectionStatus.charAt(0).toUpperCase() + record.corrosionProtectionStatus.slice(1) 
                      : 'Not Started'}
                    </div>
                </div>
                <div className="field-group mark-received">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE RECEIVED</div>
                    <div className="field-value">
                    { record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].receivedDate ? (
                      <div className="saved-supplier-display">
                        <span className="supplier-name">{moment(record.progressSteps[2].receivedDate).format('DD MMM YYYY')}</span>
                        {/* <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                        </div> */}
                      </div>
                    ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                    <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[2] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[2].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[2].receivedQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressSteps[2].receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isCorrosionAuthorized}
                              type="corrosion_protection"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationCorrosionReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[2] ? (
                        <div>{record.progressSteps[2].receivedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].receivedBy ? record.progressSteps[2].receivedBy.firstName + ' ' + record.progressSteps[2].receivedBy.lastName : ''}</div>
                  </div>
                </div>
                <div className="field-group mark-completed">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE COMPLETED</div>
                    <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[2] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{record.progressSteps[2].completedDate ? moment(record.progressSteps[2].completedDate).format('DD MMM YYYY') : ''}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">QTY COMPLETED</div>
                    <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[2] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[2].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[2].completedQty || 0} of {record.qty || 1}
                            </span>
                            {Number(record.progressSteps[2].completedQty) > Number(record.qty || 1)
                            //  && (
                            //   <AuthorizeExcess
                            //     receivedQty={corrosionCompletedQty}
                            //     expectedQty={record.qty || 1}
                            //     record={record}
                            //     currentUser={currentUser}
                            //     isAuthorized={isCorrosionCompletedAuthorized}
                            //     type="corrosion_protection"
                            //     onAuthorize={handleSaveMarkCompleted}
                            //     authorizationData={authorizationCorrosionCompletedData}
                            //   />
                            // )
                            }
                            </div>
                        ) : (
                          <div></div>
                        )}
                    </div>
                  </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[2] ? (
                        <div>{record.progressSteps[2].completedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[2] && record.progressSteps[2].completedBy ? record.progressSteps[2].completedBy.firstName + ' ' + record.progressSteps[2].completedBy.lastName : ''}</div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">TOTAL / GROSS COMPLETED</div>
                    <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[2] ? record.progressSteps[2].totalGross || "" : ""}
                    </div>
                  </div>
                </div>
                <div className="field-group">
                  <div className="tracking-stage-field">
                    <div className="field-label">SUPPLIER</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[2] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">
                          {record.progressSteps[2].supplier?.name || ''}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                  <div className="field-label">ATTACHMENTS</div>
                    <div className="field-value"></div>
                    {true ? (
                      <Form.Item>
                        <Upload>
                          <AttachmentButton style={{color: '#ffc000', borderColor: '#ffc000'}} count={0} />
                        </Upload>
                      </Form.Item>
                    ) : (
                      record && record.attachments && record.attachments.length > 0 ? 
                      <AttachmentButton style={{color: '#ffc000', borderColor: '#ffc000'}} count={record.attachments.length} /> : '-'
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col span={4}>
              <div className="tracking-stage delivery-stage">
                <div className="tracking-stage-header">DELIVERY TO SITE</div>
                <div className="tracking-stage-status">
                  <div className={`status-badge ${record && record.deliveryToSiteStatus === 'completed' ? 'completed' : (record && record.deliveryToSiteStatus === 'in_progress' ? 'in-progress' : (record && record.deliveryToSiteStatus === 'received' ? 'received' : ''))}`}>
                    {record && record.deliveryToSiteStatus ? 
                      record.deliveryToSiteStatus === 'in_progress' ? 'In Progress' : 
                      record.deliveryToSiteStatus.charAt(0).toUpperCase() + record.deliveryToSiteStatus.slice(1) 
                    : 'Not Started'}
                  </div>
                </div>
                <div className="field-group mark-received">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].receivedDate ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(record.progressSteps[3].receivedDate).format('DD MMM YYYY')}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[3].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[3].receivedQty || 0} of {record.qty || 1}
                          </span>
                          {/* <AuthorizeExcess
                            receivedQty={record.progressSteps[3].receivedQty}
                            expectedQty={record.qty || 1}
                            record={record}
                            currentUser={currentUser}
                            isAuthorized={isDeliveryAuthorized}
                            type="delivery_to_site"
                            onAuthorize={handleSaveMarkRecieved}
                            authorizationData={authorizationDeliveryReceivedData}
                          /> */}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div>{record.progressSteps[3].receivedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].receivedBy ? record.progressSteps[3].receivedBy.firstName + ' ' + record.progressSteps[3].receivedBy.lastName : ''}</div>
                  </div>
                </div>
                <div className="field-group mark-completed">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{record.progressSteps[3].completedDate ? moment(record.progressSteps[3].completedDate).format('DD MMM YYYY') : ''}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[3].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[3].completedQty || 0} of {record.qty || 1}
                          </span>
                          {Number(record.progressSteps[3].completedQty) > Number(record.qty || 1)
                          //  && (
                          //   <AuthorizeExcess
                          //     receivedQty={deliveryCompletedQty}
                          //     expectedQty={record.qty || 1}
                          //     record={record}
                          //     currentUser={currentUser}
                          //     isAuthorized={isDeliveryCompletedAuthorized}
                          //     type="delivery_to_site"
                          //     onAuthorize={handleSaveMarkCompleted}
                          //     authorizationData={authorizationDeliveryCompletedData}
                          //   />
                          // )
                          }
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div>{record.progressSteps[3].completedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[3] && record.progressSteps[3].completedBy ? record.progressSteps[3].completedBy.firstName + ' ' + record.progressSteps[3].completedBy.lastName : ''}</div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">TOTAL / GROSS COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? record.progressSteps[3].totalGross || "" : ""}
                    </div>
                  </div>
                </div>
                <div className="field-group">
                  <div className="tracking-stage-field">
                    <div className="field-label">SUPPLIER</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[3] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">
                          {record.progressSteps[3].supplier?.name || ''}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                  <div className="field-label">ATTACHMENTS</div>
                    <div className="field-value"></div>
                    {true ? (
                      <Form.Item>
                        <Upload>
                          <AttachmentButton style={{color: '#3498db', borderColor: '#3498db'}} count={0} />
                        </Upload>
                      </Form.Item>
                    ) : (
                      record && record.attachments && record.attachments.length > 0 ? 
                      <AttachmentButton style={{color: '#3498db', borderColor: '#3498db'}} count={record.attachments.length} /> : '-'
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col span={4}>
              <div className="tracking-stage receipt-stage">
                <div className="tracking-stage-header">SITE RECEIPT</div>
                <div className="tracking-stage-status">
                  <div className={`status-badge ${record && record.siteReceiptStatus === 'completed' ? 'completed' : (record && record.siteReceiptStatus === 'in_progress' ? 'in-progress' : (record && record.siteReceiptStatus === 'received' ? 'received' : ''))}`}>
                    {record && record.siteReceiptStatus ? 
                      record.siteReceiptStatus === 'in_progress' ? 'In Progress' : 
                      record.siteReceiptStatus.charAt(0).toUpperCase() + record.siteReceiptStatus.slice(1) 
                    : 'Not Started'}
                  </div>
                </div>
                <div className="field-group mark-received">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].receivedDate ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(record.progressSteps[4].receivedDate).format('DD MMM YYYY')}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[4].receivedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[4].receivedQty || 0} of {record.qty || 1}
                          </span>
                          {/* <AuthorizeExcess
                            receivedQty={record.progressSteps[4].receivedQty}
                            expectedQty={record.qty || 1}
                            record={record}
                            currentUser={currentUser}
                            isAuthorized={isSiteReceiptAuthorized}
                            type="site_receipt"
                            onAuthorize={handleSaveMarkRecieved}
                            authorizationData={authorizationDeliverytoSiteReceivedData}
                          /> */}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      { record && record.progressSteps && record.progressSteps[4] ? (
                        <div>{record.progressSteps[4].receivedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].receivedBy ? record.progressSteps[4].receivedBy.firstName + ' ' + record.progressSteps[4].receivedBy.lastName : ''}</div>
                  </div>
                </div>
                <div className="field-group mark-completed">
                  <div className="tracking-stage-field">
                    <div className="field-label">DATE COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{record.progressSteps[4].completedDate ? moment(record.progressSteps[4].completedDate).format('DD MMM YYYY') : ''}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">QTY COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? (
                        <div className="saved-qty-display">
                          <span style={{ color: Number(record.progressSteps[4].completedQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                            {record.progressSteps[4].completedQty || 0} of {record.qty || 1}
                          </span>
                          {/* <AuthorizeExcess
                            receivedQty={record.progressSteps[4].completedQty}
                            expectedQty={record.qty || 1}
                            record={record}
                            currentUser={currentUser}
                            isAuthorized={isSiteReceiptCompletedAuthorized}
                            type="site_receipt"
                            onAuthorize={handleSaveMarkCompleted}
                            authorizationData={authorizationDeliverytoSiteCompletedData}
                          /> */}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">LOCATION</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? (
                        <div>{record.progressSteps[4].completedLocation?.name || ''}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">UPDATED BY</div>
                    <div className="field-value">{record && record.progressSteps && record.progressSteps[4] && record.progressSteps[4].completedBy ? record.progressSteps[4].completedBy.firstName + ' ' + record.progressSteps[4].completedBy.lastName : ''}</div>
                  </div>
                  <div className="tracking-stage-field">
                    <div className="field-label">TOTAL / GROSS COMPLETED</div>
                    <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? record.progressSteps[4].totalGross || "" : ""}
                    </div>
                  </div>
                </div>
                <div className="field-group">
                  <div className="tracking-stage-field">
                    <div className="field-label">SUPPLIER</div>
                      <div className="field-value">
                      {record && record.progressSteps && record.progressSteps[4] ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">
                          {record.progressSteps[4].supplier?.name || ''}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="tracking-stage-field">
                  <div className="field-label">ATTACHMENTS</div>
                    <div className="field-value"></div>
                    {true ? (
                      <Form.Item>
                        <Upload>
                          <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={0} />
                        </Upload>
                      </Form.Item>
                    ) : (
                      record && record.attachments && record.attachments.length > 0 ? 
                      <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={record.attachments.length} /> : '-'
                    )}
                  </div>
                </div>
              </div>
            </Col>
              <Col span={4}>
                <div className="tracking-stage installation-stage">
                  <div className="tracking-stage-header">INSTALLATION</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${record && record.progressSteps && record.progressSteps[5] && record.progressSteps[5].status === 'completed' ? 'completed' :
                      (record && record.progressSteps && record.progressSteps[5] && record.progressSteps[5].status === 'in_progress' ? 'in-progress' : '')
                      }`}>
                      {record && record.progressSteps && record.progressSteps[5] && record.progressSteps[5].status ?
                        record.progressSteps[5].status === 'in_progress' ? 'In Progress' :
                          record.progressSteps[5].status.charAt(0).toUpperCase() + record.progressSteps[5].status.slice(1)
                        : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE INSTALLED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[5] && record.progressSteps[5].completedAt ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(record.progressSteps[5].completedAt).format('DD MMM YYYY')}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY INSTALLED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[5] ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(record.progressSteps[5].installationQty || 0) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {record.progressSteps[5].installationQty || 0} of {record.qty || 1}
                            </span>
                            {/* <AuthorizeExcess
                              receivedQty={record.progressSteps[4].receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliverytoSiteReceivedData}
                            /> */}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        { record && record.progressSteps && record.progressSteps[5] ? (
                          <div>{record.progressSteps[5].completedLocation?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{record && record.progressSteps && record.progressSteps[5] && record.progressSteps[5].completedBy ? record.progressSteps[5].completedBy.firstName + ' ' + record.progressSteps[5].completedBy.lastName : ''}</div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {record && record.progressSteps && record.progressSteps[5] ? record.progressSteps[5].totalGross || "" : ""}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value"></div>
                      {true ? (
                        <Form.Item>
                          <Upload>
                            <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={0} />
                          </Upload>
                        </Form.Item>
                      ) : (
                        record && record.attachments && record.attachments.length > 0 ? 
                        <AttachmentButton style={{color: '#2ecc71', borderColor: '#2ecc71'}} count={record.attachments.length} /> : '-'
                      )}
                    </div>
                  </div>
                </div>
              </Col>
          </Row>
          )}
          </Form>
      </Col>
      </Row>
  );
  }
  
  // For other types, dynamically render fields
  return (
    <Row>
      <Col span={24}>
        <Form
          className="ims-doc-fields-form"
          form={formRef}
          name="fields_form"
          onFinish={onFinish}
          initialValues={record}
        //   onValuesChange={handleValuesChange}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={[20, 10]}>
            {fields.map((field, index) => (
              <Col span={8} key={index}>
                {console.log("field", field)}
                {renderViewItem(field, record[field.id])}
              </Col>
            ))}
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default RevisionsExpandedRow;
